import { Response } from '../api/typegen/client/get';
import { useGetClientOffer, useGetOffer } from 'api';
import isAuthenticated from 'utils/isAuthenticated';
import useClient from './useClient';

type Props = {
  clientResponse?: Response | undefined;
};

export const useOffer = () => {
  const isLogged = isAuthenticated();
  const { client } = useClient();
  const apiOffer = useGetOffer();
  const apiClientOffer = useGetClientOffer();

  const getOfferApi = ({ clientResponse }: Props) => {
    const isLoggedAndAgeDefined = isLogged && (clientResponse || client)?.age;
    if (isLoggedAndAgeDefined) return apiClientOffer;
    return apiOffer;
  };

  return { getOfferApi };
};
